import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { LwTab } from 'redesign';
import { useTranslation } from 'react-i18next';
import { WorkFormCreateTabsProps } from './work-form-create-tabs.types';

export const WorkFormCreateTabs = ({ createTab, onTabChange }: WorkFormCreateTabsProps) => {
  const { t } = useTranslation('web-common');

  return (
    <Box mb={4}>
      <StyledTabs
        value={createTab}
        onChange={onTabChange}
        aria-label={t('work_form.create_tabs.aria_label')}
      >
        <LwTab value="single-day" label={t('work_form.create_tabs.single_day.label')} />
        <LwTab value="multi-day" label={t('work_form.create_tabs.multi_day.label')} />
      </StyledTabs>
    </Box>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  [`& div.${tabsClasses.scroller}`]: {
    [`& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(2),
      overflow: 'visible',
    },
  },
}));
